// Modules
import { theme } from '@dasa-health/components-react'
import styled from 'styled-components'

export const Container = styled.aside`
    position: relative;
    display: flex;
    background: #0037ff;
    flex: 0;
    justify-content: center;
    align-items: center;
    @media screen and (min-width: ${theme.breakpoints[2]}) {
        flex: 2;
    }
`

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    padding: 2rem 1rem;
    color: #fff;
    @media screen and (min-width: ${theme.breakpoints[2]}) {
        display: flex;
        position: relative;
        background: #000e40;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        text-align: left;
        border-radius: 1rem;
        padding: 2.5rem;
        color: #fff;
        max-width: 22rem;
        padding-top: 3.5rem;
    }
`

export const Title = styled.span<{ bgColor?: string }>`
    font-family: Dasa Sans;
    font-size: 1.25rem;
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 1.5rem */

    span {
        background-color: ${({ bgColor }) => bgColor ?? 'transparent'};
        padding: 0 0.3rem;
    }

    @media screen and (min-width: ${theme.breakpoints[2]}) {
        font-size: 2rem;
        font-style: normal;
        font-weight: 700;
        line-height: 125%; /* 2.5rem */
        letter-spacing: -0.0625rem;

        span {
            background-color: transparent;
            padding: 0;
        }
    }
`

export const Subtitle = styled.span`
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 1.5rem */
    margin-top: 1rem;
    max-width: 14rem;
    display: none;
    @media screen and (min-width: ${theme.breakpoints[2]}) {
        display: flex;
    }
`

export const LogoContainer = styled.div`
    justify-content: center;
    align-items: center;
    width: 8rem;
    height: 3.5rem;
    background-color: #fefefe;
    position: absolute;
    top: -1.75rem;
    border-radius: 0.57rem;
    display: none;
    @media screen and (min-width: ${theme.breakpoints[2]}) {
        display: flex;
    }
`

export const LogoNav = styled.img`
    height: 1.25rem;
`

export const Illustration = styled.img`
    bottom: -7rem;
    right: -6rem;
    max-width: 13rem;
    max-height: 16.25rem;
    position: absolute;
    z-index: 1;
    display: none;
    @media screen and (min-width: ${theme.breakpoints[2]}) {
        display: flex;
    }
`
